import api from "@/api/api";

const ABSOLUTE_URL_REGEX = /^https?:\/\//i;

export const getFileDownloadUrl = (path) => {
  if (!path || typeof path !== "string") {
    return "";
  }

  if (ABSOLUTE_URL_REGEX.test(path) || path.startsWith("//")) {
    return path;
  }

  const baseUrl = api?.defaults?.baseURL ? api.defaults.baseURL.replace(/\/+$/, "") : "";

  if (!baseUrl) {
    return path;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  return `${baseUrl}${normalizedPath}`;
};
